import { render, staticRenderFns } from "./factoryInfo.vue?vue&type=template&id=0602c4d4"
import script from "./factoryInfo.vue?vue&type=script&lang=js"
export * from "./factoryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports